"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { usePersona } from "@opensea/navigation";
import { bn, isAddressEqual } from "@opensea/utils";
import { useCreateListingsFlow } from "@opensea/wallet";
import { useTranslations } from "next-intl";
import { CRYPTO_PUNKS_ADDRESS } from "@/constants/constants";
import { useListItemsFragment } from "./use-list-items.fragment";
import { getItemOwnedQuantity } from "./utils";
import { isItemTradable } from "./validation/tradable";
export const useListItems = itemKeys => {
  const $ = _c(9);
  const t = useTranslations("useListItems");
  const items = itemKeys.map(_temp);
  const {
    persona
  } = usePersona();
  const mode = persona === "advanced" ? "minimized" : "full";
  let t0;
  if ($[0] !== mode) {
    t0 = {
      mode
    };
    $[0] = mode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const listItemsFlow = useCreateListingsFlow(t0);
  const getDisabledReason = () => {
    if (items.some(_temp2)) {
      return t("errors.untradeableItems");
    }
    if (items.some(_temp3)) {
      return t("errors.cryptoPunksNotSupported");
    }
    if (items.some(item_1 => item_1?.chain.identifier !== items[0]?.chain.identifier)) {
      return t("errors.differentChains");
    }
    if (items.some(_temp4)) {
      return t("errors.cannotListMoreItemsThanYouOwn");
    }
    if (items.some(_temp5)) {
      return t("errors.tradingNotAvailableForThisCollection");
    }
  };
  const disabledReason = getDisabledReason();
  const disabled = Boolean(disabledReason) || items.length === 0;
  let t1;
  if ($[2] !== items || $[3] !== listItemsFlow) {
    t1 = function listItems() {
      listItemsFlow(items.flatMap(_temp6));
    };
    $[2] = items;
    $[3] = listItemsFlow;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const listItems = t1;
  let t2;
  if ($[5] !== disabled || $[6] !== disabledReason || $[7] !== listItems) {
    t2 = {
      disabled,
      disabledReason,
      listItems
    };
    $[5] = disabled;
    $[6] = disabledReason;
    $[7] = listItems;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
function _temp(itemKey) {
  const readItem = readFragment(useListItemsFragment, itemKey);
  return readItem?.tokenId ? {
    ...readItem,
    quantity: itemKey?.quantity
  } : undefined;
}
function _temp2(item) {
  return typeof item !== "undefined" ? !isItemTradable(item) : false;
}
function _temp3(item_0) {
  return isAddressEqual(item_0?.contractAddress, CRYPTO_PUNKS_ADDRESS);
}
function _temp4(item_2) {
  return item_2?.quantity && bn(item_2.quantity).gt(getItemOwnedQuantity(item_2));
}
function _temp5(item_3) {
  return !isItemTradable(item_3);
}
function _temp6(item_4) {
  return item_4 ? [{
    chain: {
      identifier: item_4.chain.identifier
    },
    contractAddress: item_4.contractAddress,
    tokenId: item_4.tokenId,
    quantity: item_4.quantity ?? 1
  }] : [];
}